export default __webpack_public_path__ + "static/media/Resume_RCW_20250815.33afa18b.pdf";